import { useCallback, useMemo, useState } from 'react'
import { LeaseApplicationService, LeaseApplicationStatusTypesEnum } from '@propertelligent/client-api';
import AddTraspButton from '../../firstTimeUserExperience/commonCom/AddTraspButton';
import { GetImages } from '../../../utils/GetImages';
import AddNote from '../../tenants/AddNote';
import apiHelper from '../../../utils/apiHelper';
import ActionMenu from '../../../newComponents/actionMenus/action-menu';
import { Offcanvas } from 'react-bootstrap';
import { PubSub, TopicsEnum } from '../../../utils/pubsub';
const ApplicationCard = ({
  cardHeaderName,
  component,
  editButton = null,
  leaseApplicationId,
  editable,
  landlord,
  sectionName,
  handleEditClick,
  sectionToggles,
  setSectionToggles,
  fetchLeaseData,
  bname = "Edit",
  leaseApplicationStatus
}) => {
  const [addnote, setAddNote] = useState(false);
  const [displayNotes, setDisplayNotes] = useState("");
  const handleToggle = useCallback((section, value) => {
    const dataToSend = { approved: value, notes: sectionToggles[section]?.notes || "", };
    apiHelper(LeaseApplicationService.postApiLeaseApplicationReview,
      {
        successMessage: `${section} ${value ? "Approved" : "Rejected"} successfully`,
        failureMessage: `${section} unable to update`, showNotification: true
      },
      leaseApplicationId,
      section,
      dataToSend
    ).then((response) => {
      if (response?.data?.success) {
        setSectionToggles((prevToggles) => {
          const updatedToggles = { ...prevToggles };
          updatedToggles[section] = { ...updatedToggles[section], approved: value, notes: updatedToggles[section]?.notes };
          return updatedToggles;
        })

        PubSub.publish(TopicsEnum.RefreshLeaseData.toString(), null)

      }
    }).catch((error) => { console.error("Failed to update toggle:", error) });
  }, [leaseApplicationId, sectionToggles]);

  const ReviewsNotes = (type) => { setAddNote(!addnote); setDisplayNotes(type); };
  const handleCloseClick = () => { setAddNote(false); };
  const handleSaveNote = (note, type, toggleNotes, message) => {

    const dataToSend = { Notes: note, approved: toggleNotes?.approved, };
    apiHelper(LeaseApplicationService.postApiLeaseApplicationReview, {
      successMessage: message, failureMessage: "Unable to Add Note", showNotification: true,
    }, leaseApplicationId, type, dataToSend).then((response) => {
      fetchLeaseData()
    }).catch((error) => { console.error("Error saving note:", error); });
  };
  return (<><div className="common_application_card ">
    <div className={` ${(editable) || (landlord) ? 'common_application_card_header  d-flex justify-content-between align-items-center' : " common_application_card_header  "} `}>
      <div className='application_card_name'>
        <div className={` ${"BackgroundBlue"} iconstyle32 icon-wrapper  CommonRoundBackgroundNoSize`}>
          <img className="color-white-icon" alt={`${sectionName}-doc`} src={GetImages[sectionName] ?? GetImages.InfoIcon} />
        </div>
        <p className='heading black'> {cardHeaderName}</p>
      </div>
      {sectionName !== "Signature" && ((editable) || (landlord)) && (
        <div className='me-3'>{(editable) && (
          <AddTraspButton textclass="fw-600 blue" width={0} bname={bname} onClick={handleEditClick} border={false} />)}
          {(landlord) && <div className='d-flex  gap-2'>{sectionToggles?.[sectionName] && (
            <div className="section_status">
              {sectionToggles[sectionName]?.approved !== null && (<>
                <div className={`statusSign ${sectionToggles[sectionName]?.approved ? "successborder" : "errorborder"}`}>
                  <img alt="status" className="iconstyle10"
                    src={sectionToggles[sectionName]?.approved
                      ? GetImages.greenTick : GetImages.closeRedIcon} />
                </div>

                <p className={`normal_text ${sectionToggles[sectionName]?.approved ? "green" : "red"}`} >
                  {sectionToggles[sectionName]?.approved ? "Approve" : "Rejected"}
                </p></>)}
            </div>
          )}

            {(
              leaseApplicationStatus === LeaseApplicationStatusTypesEnum.Submitted ||
              leaseApplicationStatus === LeaseApplicationStatusTypesEnum.InReview
            )
              && (
              <ActionMenu menuItems={[sectionToggles[sectionName]?.approved ?
                { label: "Reject", icon: GetImages.crossIcon, action: () => { handleToggle(sectionName, false) } } :
                { label: "Approve", icon: GetImages.BlackTick, action: () => { handleToggle(sectionName, true) } }, { isDivider: true },
              { label: "Add Note", icon: GetImages.BlackFile, action: () => { ReviewsNotes(`${sectionName}`); } }]}
                trigger={<button className="action-button" aria-label="More options">
                  <img src={GetImages.dropdownIcon} alt="More options" width={20} height={20} className="action-icon" />
                </button>} />)}



          </div>}
        </div>)}
    </div>
    <div className="common_application_card_detail">{component}</div>
  </div>
    <Offcanvas
      className="offcanvas serviceRequestForm"
      show={addnote}
      onHide={() => setAddNote(false)}
      placement={"end"}
      scroll={true} >
      <Offcanvas.Header className="canvasHeader" closeButton>
        <Offcanvas.Title>Notes </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <AddNote
          onClose={handleCloseClick}
          toggle={sectionToggles[sectionName]}
          type={displayNotes}
          onSave={handleSaveNote}
          setAddNote={setAddNote}

        />
      </Offcanvas.Body>
    </Offcanvas>
  </>)
}
export default ApplicationCard